<template>
  <div>
    <div class="PaB-menu-home">
      <div class="PaB-card PaB-card--category" v-for="category in categories" v-bind:key="category.slug">
        <router-link :to="{name: 'product-listing', params: { category: category.slug } }">

          <header class="PaB-card__header"
            v-if="category.image && category.image.md && widgetOptions.style.product_images">
            <div class="PaB-card__media">
              <lazy-image :src="category.image.md" class="PaB-attachment-card-lg PaB-size-card-lg" :alt="category.name" />
            </div>
          </header>

          <div class="PaB-card__body">
            <h3 class="PaB-card__title">{{ category.name }}</h3>
            <p class="PaB-card__description">{{ category.description }}</p>
            <span class="PaB-link">View Products</span>
          </div>

        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
.PaB-card {
  border: 1px solid rgba(#7f7f7f, 0.4);
  display: flex;
  overflow: hidden;
  width: 100%;
  text-align: center;
  position: relative;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  > a {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    color: inherit;
    &:hover {
      color: inherit;
    }
  }

  &__header {
    position: relative;
    overflow: hidden;
    box-shadow: inset 0 0 140px rgba(#7f7f7f, 0.5);
  }
  &__media {
    height: 0;
    padding-bottom: 200 / 360 * 100%;
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;

    img {
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &__body {
    flex: 1 1 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .PaB-link {
      margin-top: auto;
    }
  }
  &__title {
    font-size: 23px;
    margin-bottom: 0;
  }
}

.PaB-menu-home {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 40px;
}

.PaB-card {
  margin: 7px;
  flex: 1 1 calc(100% - 15px);

  @media screen and (min-width: 400px) {
    flex: 1 1 calc(50% - 15px);
    min-width: 320px;
  }
}
</style>

<script>
import LazyImage from '@/components/LazyImage'

export default {
  components: {
    LazyImage
  },
  computed: {
    categories () {
      return this.$store.state.products.categories
    }
  },
  created () {
    this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
  }
}
</script>
